"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserRoles = void 0;
var UserRoles;
(function (UserRoles) {
    UserRoles["UserAdmin"] = "user-admin";
    UserRoles["ShopRead"] = "read-shop";
    UserRoles["ShopWrite"] = "write-shop";
    UserRoles["ShopExport"] = "export-shop";
    UserRoles["BannersRead"] = "read-banners";
    UserRoles["BannersWrite"] = "write-banners";
    UserRoles["AccountsRead"] = "read-accounts";
    UserRoles["AccountsWrite"] = "write-accounts";
    UserRoles["InAppEventsRead"] = "read-in-app-events";
    UserRoles["InAppEventsWrite"] = "write-in-app-events";
    UserRoles["PriceAutomationRead"] = "read-price-automation";
    UserRoles["PriceAutomationWrite"] = "write-price-automation";
    UserRoles["ReleaseManagementRead"] = "read-release-management";
    UserRoles["ReleaseManagementWrite"] = "write-release-management";
    UserRoles["PortalReadPost"] = "read-portal-post";
    UserRoles["PortalWritePost"] = "write-portal-post";
    UserRoles["PortalReadSchedule"] = "read-portal-schedule";
    UserRoles["PortalWriteSchedule"] = "write-portal-schedule";
    UserRoles["PortalReadCategory"] = "read-portal-category";
    UserRoles["PortalWriteCategory"] = "write-portal-category";
    UserRoles["MediaReadWrite"] = "read-write-media";
    UserRoles["ChangeLogReadWrite"] = "read-write-changelog";
    UserRoles["GiftDelete"] = "delete-gift";
    UserRoles["GiftWrite"] = "write-gift";
    UserRoles["GiftRead"] = "read-gift";
    UserRoles["GiftClaim"] = "claim-gift";
    UserRoles["TranslationWrite"] = "write-translation";
    UserRoles["TranslationRead"] = "read-translation";
})(UserRoles || (exports.UserRoles = UserRoles = {}));
